import { useEffect, useRef, useState } from 'react';

/**
 * Returns [ref, near] — `near` flips to true (once) when the referenced
 * element approaches the viewport. Used to defer heavy content (3D scenes,
 * large media) so mobile devices don't pay the cost on initial load.
 */
export function useNearViewport(rootMargin = '160px') {
  const ref = useRef(null);
  const [near, setNear] = useState(false);

  useEffect(() => {
    if (near) return undefined;
    const el = ref.current;
    if (!el) return undefined;
    if (typeof IntersectionObserver === 'undefined') {
      // Very old browsers: load immediately rather than never.
      setNear(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setNear(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [near, rootMargin]);

  return [ref, near];
}
